import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { Language } from '../../i18n/translations';
import './LanguageToggle.css';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();

  const options: { code: Language; label: string }[] = [
    { code: 'en', label: 'EN' },
    { code: 'es', label: 'ES' },
  ];

  return (
    <div className="language-toggle" role="group" aria-label="Language">
      <Languages size={16} className="language-toggle-icon" aria-hidden="true" />
      {options.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          className={`language-toggle-btn ${language === code ? 'active' : ''}`}
          onClick={() => setLanguage(code)}
          aria-label={t.language.switchTo.replace('{{language}}', t.language[code])}
          aria-pressed={language === code}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;
